import { Container, Button } from "react-bootstrap";
import { floating } from "../helpers";
import { useEffect } from "react";
import { CodereHelmet, SPEEDSIZE_PREFIX } from "../../../App";

export default function Goldenchips({ flag }) {
  useEffect(() => {
    let json = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "¿Qué valor tienen las fichas doradas en Codere?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Nuestras fichas doradas gratis, tienen un valor de $1.000 COP y puedes usarlas inmediatamente cuando las tengas para maximizar tus ganancias.",
          },
        },
        {
          "@type": "Question",
          name: "¿Puedo ganar dinero real con las fichas doradas Codere?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Conforme a nuestros términos y condiciones, cada usuario puede utilizar sus Fichas Doradas gratis y liberarlas para obtener ganancias reales.",
          },
        },
        {
          "@type": "Question",
          name: "¿Son seguras las promociones de Codere?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En Codere promovemos el juego responsable y seguro, conforme a nuestra política autorizada por el operador Coljuegos, dado a que nuestro principal objetivo es garantizarte la mejor experiencia del mercado.",
          },
        },
      ],
    };
    let title = "Golden Chips Online » Juega con Fichas Doradas";
    let desc =
      "Las Fichas Doradas de Codere te permiten jugar sin apostar tu dinero real. Descubre cómo obtenerlas y disfruta de la mejor experiencia en juegos de casino";
    let can = "https://www.codere.com.co/ayuda/golden-chips";

    CodereHelmet(title, desc, can, [json]);
  }, []);

  const top_par = {
    h1: "Conoce las Fichas Doradas y vive una gran experiencia con Codere ",
    p: "En este segmento conocerás todo lo relacionado con las fichas doradas y cómo puedes usarlas para maximizar tus ganancias en nuestro casino Codere. Te daremos a conocer los siguientes ítems:",
    ul: [
      "¿Qué son las Fichas Doradas en Codere?",
      "¿Cuáles son las ventajas de usar las Fichas Doradas?",
      "¿Cómo puedes obtener las Fichas Doradas en Codere?",
      "¿Qué juegos están disponibles con Fichas Doradas en Codere?",
      "Preguntas Frecuentes sobre las Fichas Doradas",
    ],
  };

  const p1 = {
    id: "p1",
    h2: "¿Qué son las Fichas Doradas en Codere?",
    p: "Las Golden Chips o Fichas Doradas se constituyen en un bono que ofrece Codere para que, en línea, los jugadores puedan probar el o los juegos seleccionados sin arriesgar su dinero real. Estas Fichas Doradas, podrás utilizarlas en los juegos relacionados con Mesas, es decir Blackjack, Ruleta, Baccarat. ",
    inner: [
      {
        h3: "Ventajas de las Fichas Doradas",
        p: "Algunas ventajas de usar las Fichas Doradas con Codere son:",
        ul: [
          "Son una prueba gratuita y te permiten probar varias jugadas y construir mejores estrategias sin ningún riesgo.",
          "Tendrás más diversión gracias a nuestra gran experiencia de juego.",
          "Es una excelente manera de descubrir nuevos juegos y mesas en directo.",
        ],
      },
      {
        h3: "¿Cómo Obtenerlas en Codere?",
        p: "Con Codere, tú puedes obtener las Fichas Doradas ya sea aprovechando nuestra promoción “Juego de la Semana” donde te entregamos cinco (5) gratis. También puedes aprovechar cualquier otra promoción que involucre las mismas.",
      },
    ],
  };

  const p2 = {
    id: "p2",
    h2: "Juegos Disponibles con Fichas Doradas en Codere",
    p: "En Codere Colombia, tienes bastantes juegos para divertirte con tus Fichas Doradas:",
    ul: [
      "Live Football",
      "Ruleta Coderista",
      "Quantum Roulette Live",
      "Premium Blackjack",
      "Mega Fire Blaze Roulette Live",
    ],
    p2: "Con estos juegos, puedes alcanzar tus fichas conforme a la promoción “Juego de la Semana” u otra promoción donde se entreguen Fichas Doradas gratis.",
  };

  const p3 = {
    id: "p3",
    h2: "Anímate a disfrutar tus Fichas Doradas gratis",
    p: "En Codere tienes varias formas de ganar, una de ellas son nuestras Fichas Doradas gratis y tú puedes aprovecharlas en grande con nuestras increíbles promociones. Regístrate y diviértete en grande.\nRecuerda: cualquier duda que tengas sobre nuestras promociones puedes resolverla en los canales de atención al cliente, tanto en la plataforma, línea telefónica nacional 01- 8000-975827 o a través del correo apuestas@codere.com.",
  };

  const preguntas = {
    id: "preguntas",
    h2: "FAQ (Preguntas Frecuentes)",
    inner: [
      {
        h3: "¿Qué valor tienen las fichas doradas en Codere?",
        p: "Nuestras fichas doradas gratis, tienen un valor de $1.000 COP y puedes usarlas inmediatamente cuando las tengas para maximizar tus ganancias.",
      },
      {
        h3: "¿Puedo ganar dinero real con las fichas doradas Codere?",
        p: "Conforme a nuestros términos y condiciones, cada usuario puede utilizar sus Fichas Doradas gratis y liberarlas para obtener ganancias reales.",
      },
      {
        h3: "¿Son seguras las promociones de Codere?",
        p: "En Codere promovemos el juego responsable y seguro, conforme a nuestra política autorizada por el operador Coljuegos, dado a que nuestro principal objetivo es garantizarte la mejor experiencia del mercado.",
      },
    ],
  };

  return (
    <div className="codere-green">
      {floating("Juega sin riesgos")}
      <div
        className="top-bg-seo "
        style={{
          backgroundImage: `url(${SPEEDSIZE_PREFIX}https://www.codere.com.co/colombia/images/seo-ayuda/golden-chips-${
            flag ? "mobile" : "desktop"
          }.jpg)`,
          backgroundSize: "cover",
        }}
      ></div>

      <Container>
        <div>
          <h1 className="header mt-4 mb-3">{top_par.h1}</h1>
          <p>{top_par.p}</p>
          <ul>
            {top_par.ul.map((li, i) => (
              <li key={i}>{li}</li>
            ))}
          </ul>
        </div>

        <div id={p1.id}>
          <h2>{p1.h2}</h2>
          <p>{p1.p}</p>
          <div className="px-3">
            {p1.inner.map((inn, i) => (
              <div className="mt-3" key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
                {inn.ul && (
                  <ul>
                    {inn.ul.map((li, j) => (
                      <li key={j}>{li}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        <div id={p2.id}>
          <h2 className="mt-4 mb-3">{p2.h2}</h2>
          <p>{p2.p}</p>
          <ul>
            {p2.ul.map((li, i) => (
              <li key={i}>{li}</li>
            ))}
          </ul>
          <p>{p2.p2}</p>
        </div>

        <div id={p3.id}>
          <h2 className="mt-4 mb-3">{p3.h2}</h2>
          {p3.p.split("\n").map((pi, i) => (
            <p key={i}>{pi}</p>
          ))}
        </div>

        <div id={preguntas.id}>
          <h2>{preguntas.h2}</h2>
          <div className="px-3">
            {preguntas.inner.map((inn, i) => (
              <div key={i}>
                <h3>{inn.h3}</h3>
                <p>{inn.p}</p>
              </div>
            ))}
          </div>

          <Button
            href={"https://m.codere.com.co/deportesCol/#/mso/RegistroCONewPage"}
            className="cas-reg-btn"
            rel="nofollow"
          >
            Registrate
          </Button>
        </div>
      </Container>
    </div>
  );
}
